import script from "./Search.vue?vue&type=script&lang=ts&setup=true"
export * from "./Search.vue?vue&type=script&lang=ts&setup=true"

import "./Search.vue?vue&type=style&index=0&id=7f3ebfa4&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f3ebfa4"]])

export default __exports__